import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { messageClear } from "../store/reducers/authReducer"; /*obtneerr la url de envio*/
import toast from "react-hot-toast";
import { FadeLoader } from "react-spinners";

const PoliticadeSeguridadyPrivacidad = () => {
  const navigate = useNavigate();
  const { loader, errorMessage, successMessage } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  /*cambiar el dispath*/
  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
 
  }, [successMessage, errorMessage, dispatch, navigate]);

  return (
    <div>
      {loader && (
        <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]">
          <FadeLoader />
        </div>
      )}

      <Header />
      <div className="bg-slate-200 mt-4">
        <div className="w-full justify-center items-center p-10">
          <div className="max-w-6xl  mx-auto bg-white rounded-md">
            <div className="px-8 py-8">
              <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Política de Seguridad y Privacidad</h2>

              <ul className="space-y-4 list-disc pl-5 text-gray-700">
                <li className="pb-2 border-b border-gray-100">Toda la información de las personas registradas dentro de nuestra tienda virtual es solo usada con fines de trabajo.</li>

                <li className="pb-2 border-b border-gray-100">Toda los datos de nuestros clientes son guardados con alta seguridad en nuestra base de datos</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PoliticadeSeguridadyPrivacidad;
